import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues5, LocalService, PageKey, StartUpType, Status } from '../../../service/local.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { MessageComponent } from 'src/app/popups/message/message.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Constant } from 'src/app/supporting/constants';

@Component({
  selector: 'app-startup',
  templateUrl: './startup.component.html',
  styleUrls: ['./startup.component.scss']
})
export class StartupComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["startup", "common", "login"]; items: KeyValues5[]; headerSlide: KeyValues5[];
  timeLeft: number = 0; frequencyInMilliSeconds: number = 3000; interval;
  isPrimiaryServiceVerified = false; isRequeCheckInitiated = false;

  constructor(public localService: LocalService, private modalService: NgbModal, private httpCall: HttpClient, private languageManagementService: LanguageManagementService, private route: ActivatedRoute, private router: Router, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    if (!this.isPrimiaryServiceVerified) {
      (async () => {
        await this.onCheckPrimaryService();
      })();
    }
  }

  onCheckPrimaryService() {
    const isPrimaryServiceDownBefore = this.localService.isPrimaryServiceDown;
    this.httpCall.get(environment.url.service + 'version').toPromise()
      .then(response => {
        const result = response as any;
        this.localService.isPrimaryServiceDown = !(result && result.version && result.version.length > 5);
        this.isPrimiaryServiceVerified = true;
        if (!isPrimaryServiceDownBefore && this.localService.isPrimaryServiceDown) {
          this.configurationManagementService.onEnsureServiceDown();
        }
        if (!this.localService.reques) {
          this.onCheckReques();
        } else {
          this.onInitiate();
        }
      }).catch(error => {
        this.localService.isPrimaryServiceDown = true;
        this.isPrimiaryServiceVerified = true;
        if (!isPrimaryServiceDownBefore && this.localService.isPrimaryServiceDown) {
          this.configurationManagementService.onEnsureServiceDown();
        }
        if (!this.localService.reques) {
          this.onCheckReques();
        } else {
          this.onInitiate();
        }
      });
  }

  onInitiateVersionCheck() {
    setTimeout(() => { //To avoid NG0100 error
      if (this.localService.languageContent && this.localService.languageContent.login) {
        setTimeout(() => { //To avoid NG0100 error
          if (environment.is_whitelist_enabled) {
            setTimeout(() => {
              if (this.localService.languageContent && this.localService.languageContent.login)
                this.localService.showInformation(this.localService.languageContent.login.while_list_only);
            }, 500);
          }

          if (environment.current_environment_name !== "Local") {
            this.configurationManagementService.isVersionMatched().subscribe(result => {
              if (!result || result.status != Status.Success) {
                let message = this.localService.languageContent.login.refresh_app;
                message = this.localService.replaceAll(message, '##var1##', Constant.Version);
                message = this.localService.replaceAll(message, '##var2##', result?.value ?? '');

                const modalRef = this.modalService.open(MessageComponent);
                modalRef.componentInstance.IsHtmlMessage = true;
                modalRef.componentInstance.timerValue = 30;
                modalRef.componentInstance.message = message;
                modalRef.componentInstance.customButtonText = this.localService.languageContent.login.refresh_app_btn;
                modalRef.result.then((result) => {
                  window.location.reload();
                });
              }
            });
          }
        }, 0);
      }
    }, 100);
  }

  onCheckReques() {
    if (!this.isRequeCheckInitiated) {
      this.isRequeCheckInitiated = true;
      if (!this.localService.reques) {
        this.configurationManagementService.getReques().subscribe(result => {
          if (result && result.status == Status.Success) {
            this.localService.reques = this.localService.decryptCrypto(result.value, environment.ui);
            this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
            this.onInitiate();
          }
        });
      } else {
        this.onInitiate();
      }
    } else {
      this.onInitiate();
    }
  }

  onInitiate() {
    if (this.localService.loggedMember) {
      this.localService.setLoggedMember(this.localService.loggedMember);
    } else {
      if ((this.router.url == '' || this.router.url == '/') && !this.localService.selected.user) {
        this.localService.onClosePopups();
      }
      this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
      this.startTimer();
      this.onLoad();
      this.route.params.subscribe(routeParams => {
        let languageCode = routeParams.languageCode;
        if (languageCode) {
          if (this.localService.selectedLanguageCode != languageCode) {
            let languageId = this.localService.getLanguageId(languageCode);
            if (languageId) {
              this.localService.selected.applicationLanguage = languageId;
              this.languageManagementService.onLanguageChanged();
            }
          }
        }
      });
    }
  }

  onLanguageChanged() {
    this.onLoad();
  }

  onLoad() {
    this.configurationManagementService.getStartUpsToDisplay().subscribe(result => {
      this.items = result;
      this.headerSlide = this.items.filter(x => x.v1 == StartUpType.HeaderSlide.toString());
      this.onInitiateVersionCheck();
      if (this.localService.redirectUrl != '' && [PageKey.QrCode, PageKey.Guide, PageKey.PricingCalculator, PageKey.LoginWithLanguage].includes(this.localService.navigateToPage)) {
        setTimeout(() => {
          if ([PageKey.QrCode].includes(this.localService.navigateToPage)) {
            this.localService.onNavigateToPage(this.localService.navigateToPage);
          } else {
            if (this.localService.redirectUrl.indexOf("//www") > -1) {
              this.router.navigate([this.localService.redirectUrl.replace(environment.url.app, "")]);
            } else {
              this.router.navigate([this.localService.redirectUrl.replace(environment.url.app_without_www, "")]);
            }
          }
        }, 1000);
      }
    });
  }

  getFeatures(parentId = ''): KeyValues5[] {
    let items: KeyValues5[] = [];
    if (parentId == '') {
      items = this.items.filter(x => x.v1 == StartUpType.FeatureCategory.toString());
    } else {
      items = this.items.filter(x => x.v4 == parentId);
    }
    return items;
  }

  startTimer() {
    this.interval = setInterval(() => {
      this.timeLeft++;
      if (this.headerSlide && this.timeLeft == this.headerSlide.length)
        this.timeLeft = 0;
    }, this.frequencyInMilliSeconds);
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }

  onStartupClick(index: number) {
    if (this.localService.selected.user == '') {
      this.localService.showMessage(this.localService.languageContent.login.login_request);
    } else {
      switch (index) {
        case 1: {
          this.router.navigate(['/sellers']);
        } break;
        case 2: {
          this.router.navigate(['/search']);
        } break;
        case 3: {
          this.router.navigate(['/deliverer', this.localService.selected.countryCode]);
        } break;
      }
    }
  }
}
